import React, { useMemo, useState, useEffect, useContext } from "react";
import { ContextEngine } from "../engine/ContextEngine";

const RowControlModal = ({ rowIds = [], control, position, closeModal }) => {
  const { context, updateContext } = useContext(ContextEngine);
  const tableId = "defaultTable";
  
  const unitIndex = context.context_units.findIndex((u) => u.id === tableId);
  const unit = context.context_units[unitIndex];

  // Map rowIds to their actual data objects from the unit
  const targetRows = useMemo(() => {
    return unit?.data.filter(item => rowIds.includes(item.row_id)) || [];
  }, [unit, rowIds]);

  const { bind, label, options = [], multi = false } = control;
  
  // Initial state: If multi, collect all unique values currently in meta[bind]
  const [selected, setSelected] = useState(() => {
    if (multi) {
      const allVals = targetRows.flatMap(r => r.meta?.[bind] || []);
      return [...new Set(allVals)].map(String);
    }
    return String(targetRows[0]?.meta?.[bind] || "");
  });

  const handleSave = () => {
    // Update each specific row in the context
    targetRows.forEach(row => {
      const rowIndex = unit.data.findIndex(r => r.row_id === row.row_id);
      if (rowIndex !== -1) {
        const path = `context_units.${unitIndex}.data.${rowIndex}.meta.${bind}`;
        updateContext(path, selected);
      }
    });
    closeModal();
  };

  const handleToggle = (val) => {
    if (!multi) {
      setSelected(val);
    } else {
      setSelected(prev => 
        prev.includes(val) ? prev.filter(v => v !== val) : [...prev, val]
      );
    }
  };

  const handleSelectAll = (e) => {
    if (multi) {
      setSelected(options.map(String));
    }
  };

  const handleUnselectAll = (e) => {
    setSelected([]);
  };
  const isAllSelected = selected.length === options.length;

  if (!unit || !targetRows.length) return null;

  return (
    <div className="modal-container" style={{
      position: "fixed", top: position?.y, left: position?.x,
      zIndex: 1000, background: "#1c1c1c", padding: '15px', border: '1px solid #444', borderRadius: '8px',
      color: "#fff" // Light text color for dark mode
    }}>
      <div style={{ fontWeight: "bold", marginBottom: "10px" }}>
        {label} ({targetRows.length} rows)
      </div>
      
      {/* Select All / Unselect All for Multi-select */}
      {multi && (
        <div style={{ marginBottom: "10px" }}>
          <label style={{ cursor: "pointer", display: "block", color: "#ccc" }}>
            <input 
              type="checkbox" 
              checked={isAllSelected} 
              onChange={() => isAllSelected ? handleUnselectAll() : handleSelectAll()}
              style={{ accentColor: "#4CAF50" }} // Green checkbox accent
            />
            {isAllSelected ? "Unselect All" : "Select All"}
          </label>
        </div>
      )}

      <div className="options-list" style={{ margin: '10px 0', maxHeight: '200px', overflowY: 'auto', borderTop: '1px solid #444' }}>
        {options.map(opt => (
          <label key={opt} style={{ display: 'block', cursor: 'pointer', color: "#ddd" }}>
            <input 
              type={multi ? "checkbox" : "radio"} 
              checked={multi ? selected.includes(String(opt)) : selected === String(opt)}
              onChange={() => handleToggle(String(opt))}
              style={{ accentColor: "#4CAF50" }} // Green checkbox accent
            /> {opt}
          </label>
        ))}
      </div>

      <div style={{ display: 'flex', gap: '10px', justifyContent: 'flex-end' }}>
        <button 
          onClick={closeModal} 
          style={{
            backgroundColor: "#f44336", color: "white", border: "none", padding: "6px 12px", borderRadius: "4px", cursor: "pointer"
          }}>
          Cancel
        </button>
        <button 
          onClick={handleSave} 
          style={{
            backgroundColor: "#007bff", color: "white", border: "none", padding: "6px 12px", borderRadius: "4px", cursor: "pointer"
          }}>
          Apply
        </button>
      </div>
      <style>{`@keyframes fadeIn { from { opacity: 0; transform: translateY(-5px); } to { opacity: 1; transform: translateY(0); } }`}</style>
    </div>
  );
};

export default RowControlModal;
